module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-bw.f9293c6a.png";